import { Button, Card, CardContent, FormControl, Grid, TextField } from '@mui/material'
import { useForm } from '../../../../hooks/useForm'
import { useState } from "react"

const calculadorEngancheFormFields = {
    monto_venta: 0,
    clean_monto_venta:0
}

const FormCalculadorEnganche = () => {

    const [range, setRange] = useState(0)

    const [enganche, setEnganche] = useState(0)

    const { monto_venta, clean_monto_venta, onInputChange, numberFormatter, onInputChangeForNumber } = useForm(calculadorEngancheFormFields)

    const handleSubmitForm = (e) => {
        e.preventDefault()
        const enganche_format = clean_monto_venta * (range * 0.01) 
        setEnganche(numberFormatter.format(enganche_format))
    }

    return (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card style={{zIndex:'1'}}>
                    <CardContent>
                        <div className='h4 mt-1 mb-1'> Calculador De Enganche</div>
                        <div className="border-bottom border-dark"></div>

                        <form onSubmit={handleSubmitForm}>
                            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:4}}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>

                                    <FormControl fullWidth>
                                        <label htmlFor="">Monto Venta (Q)</label>
                                        <TextField
                                            id="monto_venta"
                                            name="monto_venta"
                                            value={monto_venta}
                                            onChange={onInputChangeForNumber}
                                            placeholder="Monto Venta"
                                            size='small'
                                            type="text"
                                            variant="standard"
                                            InputProps={{
                                                readOnly: false,
                                            }}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt:4}}>

                                    <FormControl fullWidth>
                                        <label>Ingrese: {range}%</label>
                                        <TextField
                                            type='range'
                                            value={range}
                                            onChange={changeEvent => setRange(changeEvent.target.value)}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt:4}}>
                                    <FormControl fullWidth>
                                        <label>Total de Enganche (Q)</label>
                                        <TextField
                                            id="enganche"
                                            name="enganche"
                                            value={enganche}
                                            onChange={onInputChange}
                                            size='small'
                                            type="text"
                                            variant="filled"
                                            // hiddenLabel
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container sx={{mt:4}}>
                                <Grid item>
                                    <div className='update ml-auto mr-auto'>
                                        <Button 
                                            style={{background: "#47c4c7", borderRadius: '5px'}}
                                            variant="contained"
                                            type='submit'>
                                            Calcular
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

export {
    FormCalculadorEnganche
}